webpackJsonp([1],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
var transitionDuration = exports.transitionDuration = 300;

var defaults = {
  styles: {
    image: {
      cursor: 'zoom-in'
    },
    zoomImage: {
      cursor: 'zoom-out',
      position: 'absolute',
      transition: 'transform ' + transitionDuration + 'ms',
      transform: 'translate3d(0, 0, 0) scale(1)',
      transformOrigin: 'center center',
      willChange: 'transform, top, left'
    },
    zoomContainer: {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 999
    },
    overlay: {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: '#fff',
      opacity: 0,
      transition: 'opacity ' + transitionDuration + 'ms'
    }
  }
};

exports.default = defaults;

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bridge-big.0d2f9df.jpg";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bridge.978c16a.jpg";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(57),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(15);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ImageZoom = __webpack_require__(52);

var _ImageZoom2 = _interopRequireDefault(_ImageZoom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var src = __webpack_require__(14); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var bigsrc = __webpack_require__(13);

exports.default = {
  name: 'app',
  components: {
    ImageZoom: _ImageZoom2.default
  },
  data: function data() {
    return {
      src: src,
      bigsrc: bigsrc
    };
  }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(2);

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

var _Zoom = __webpack_require__(54);

var _Zoom2 = _interopRequireDefault(_Zoom);

var _defaults = __webpack_require__(1);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPortal(tag) {
  var portal = document.createElement(tag);
  document.body.appendChild(portal);
  return portal;
} //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function removePortal(portal) {
  document.body.removeChild(portal);
}

exports.default = {
  data: function data() {
    return {
      hasAlreadyLoaded: false,
      isZoomed: false,
      image: this.defaultImage
    };
  },


  props: {
    shouldPreload: {
      type: Boolean,
      default: false
    },
    shouldReplaceImage: {
      type: Boolean,
      default: true
    },
    shouldRespectMaxDimension: {
      type: Boolean,
      default: false
    },
    zoomMargin: {
      type: Number,
      default: 40
    },
    defaultStyles: {
      type: Object,
      default: function _default() {
        // eslint-disable-line
        return {
          zoomContainer: {},
          overlay: {},
          image: {},
          zoomImage: {}
        };
      }
    },
    zoomImage: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    defaultImage: {
      type: Object,
      required: true
    },
    shouldHandleZoom: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    onZoom: {
      type: Function,
      default: function _default() {}
    },
    onUnzoom: {
      type: Function,
      default: function _default() {}
    }
  },

  watch: {
    isZoomed: function isZoomed(val, oldVal) {
      if (val !== oldVal) {
        if (val) this.renderZoomed();else if (this.zoomInstance) this.zoomInstance.handleUnzoom();
      }
    }
  },

  mounted: function mounted() {
    if (this.isZoomed) this.renderZoomed();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeZoomed();
  },


  methods: {
    renderZoomed: function renderZoomed() {
      this.portal = createPortal('div');

      var zoomImage = this.zoomImage,
          defaultStyles = this.defaultStyles,
          hasAlreadyLoaded = this.hasAlreadyLoaded,
          shouldRespectMaxDimension = this.shouldRespectMaxDimension,
          zoomMargin = this.zoomMargin,
          handleUnzoom = this.handleUnzoom;


      var image = this.$refs.image;

      var ZoomInstance = _vue2.default.extend({ // eslint-disable-line
        template: '<Zoom\n                    :zoomImage="zoomImage"\n                    :defaultStyles="defaultStyles"\n                    :image="image"\n                    :hasAlreadyLoaded="hasAlreadyLoaded"\n                    :shouldRespectMaxDimension="shouldRespectMaxDimension"\n                    :zoomMargin="zoomMargin"\n                    :onUnzoom="onUnzoom" />',
        components: {
          Zoom: _Zoom2.default
        },
        data: function data() {
          return {
            zoomImage: zoomImage,
            image: image,
            defaultStyles: defaultStyles,
            hasAlreadyLoaded: hasAlreadyLoaded,
            shouldRespectMaxDimension: shouldRespectMaxDimension,
            zoomMargin: zoomMargin
          };
        },

        methods: {
          onUnzoom: handleUnzoom
        }
      });

      var zoomInstance = new ZoomInstance().$mount(this.portal);

      /**
      * the $mount method upon will change
      * the dom node of portal, so get again here
      */
      this.portal = zoomInstance.$el;

      this.zoomInstance = zoomInstance;
    },
    removeZoomed: function removeZoomed() {
      if (this.portal) {
        // this.zoomInstance.$destory();
        removePortal(this.portal);
        delete this.zoomInstance;
        delete this.portal;
      }
    },
    getImageStyle: function getImageStyle() {
      var style = (0, _assign2.default)({}, this.isZoomed && { visibility: 'hidden' });

      return (0, _assign2.default)({}, _defaults2.default.styles.image, style, this.defaultStyles.image, this.image.style);
    },
    handleZoom: function handleZoom() {
      if (this.shouldHandleZoom(event)) {
        this.isZoomed = true;
        this.$nextTick(this.onZoom);
      }
    },


    /**
    * This gets passed to the zoomed component as a callback
    * to trigger when the time is right to shut down the zoom.
    * If `shouldReplaceImage`, update the normal image we're showing
    * with the zoomed image -- useful when wanting to replace a low-res
    * image with a high-res one once it's already been downloaded.
    * It also cleans up the zoom references and then updates state.
    */
    handleUnzoom: function handleUnzoom(src) {
      var _this = this;

      return function () {
        var changes = (0, _assign2.default)({}, { isZoomed: false }, { hasAlreadyLoaded: true }, _this.shouldReplaceImage && { image: (0, _assign2.default)({}, _this.image, { src: src }) });

        _this.removeZoomed();

        (0, _assign2.default)(_this, changes);

        _this.$nextTick(_this.onUnzoom);
      };
    }
  }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(2);

var _assign2 = _interopRequireDefault(_assign);

var _defaults = __webpack_require__(1);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    isVisible: {
      type: Boolean,
      required: true
    },
    defaultStyle: {
      type: Object,
      required: true
    }
  },

  // mounted() {
  //   this.isVisible = true;
  // },

  computed: {
    customStyle: function customStyle() {
      // convert bool to 0 or 1
      var opacity = this.isVisible & 1; // eslint-disable-line
      return (0, _assign2.default)({}, _defaults2.default.styles.overlay, { opacity: opacity }, this.defaultStyle);
    }
  }
}; //
//
//
//

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(2);

var _assign2 = _interopRequireDefault(_assign);

var _Overlay = __webpack_require__(53);

var _Overlay2 = _interopRequireDefault(_Overlay);

var _defaults = __webpack_require__(1);

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Figure out how much to scale based
 * solely on no maxing out the browser
 */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function getScale(_ref) {
  var width = _ref.width,
      height = _ref.height,
      zoomMargin = _ref.zoomMargin;

  var scaleX = window.innerWidth / (width + zoomMargin);
  var scaleY = window.innerHeight / (height + zoomMargin);

  return Math.min(scaleX, scaleY);
}

/**
 * Figure out how much to scale so you're
 * not larger than the original image
 */
function getMaxDimensionScale(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      naturalWidth = _ref2.naturalWidth,
      naturalHeight = _ref2.naturalHeight,
      zoomMargin = _ref2.zoomMargin;

  var scale = getScale({ width: naturalWidth, height: naturalHeight, zoomMargin: zoomMargin });
  var ratio = naturalWidth > naturalHeight ? naturalWidth / width : naturalHeight / height;

  return scale > 1 ? ratio : scale * ratio;
}

exports.default = {
  data: function data() {
    return {
      hasLoaded: false,
      isZoomed: true,
      src: this.image.currentSrc || this.image.src
    };
  },


  props: {
    zoomImage: {
      type: Object,
      required: true
    },
    image: {
      type: HTMLImageElement,
      required: true
    },
    hasAlreadyLoaded: {
      type: Boolean,
      required: true
    },
    defaultStyles: {
      type: Object,
      required: true
    },
    zoomMargin: {
      type: Number,
      default: 0
    },
    onUnzoom: {
      type: Function,
      default: function _default() {}
    },
    shouldRespectMaxDimension: {
      type: Boolean
    }
  },

  components: {
    Overlay: _Overlay2.default
  },

  mounted: function mounted() {
    var hasAlreadyLoaded = this.hasAlreadyLoaded,
        _zoomImage = this.zoomImage,
        src = _zoomImage.src,
        srcSet = _zoomImage.srcSet;


    this.hasLoaded = true;
    if ((src || srcSet) && !hasAlreadyLoaded) this.fetchZoomImage();
    this.addListeners();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeListeners();
  },


  computed: {
    ZoomContainerStyle: function ZoomContainerStyle() {
      return (0, _assign2.default)({}, _defaults2.default.styles.zoomContainer, this.defaultStyle);
    }
  },

  methods: {
    fetchZoomImage: function fetchZoomImage() {
      var _this = this;

      var _zoomImage2 = this.zoomImage,
          src = _zoomImage2.src,
          srcSet = _zoomImage2.srcSet,
          sizes = _zoomImage2.sizes;

      var img = new Image();

      img.src = src;
      if (srcSet) img.srcset = srcSet;
      if (sizes) img.sizes = sizes;

      var onLoad = function onLoad() {
        if (_this.isZoomed) {
          _this.hasLoaded = true;
          _this.src = img.currentSrc || img.src;
        }

        /**
        * If using srcset, future resize events can trigger
        * additional onload events to fire.
        * Remove listener after first load
        */
        img.removeEventListener('load', onLoad);
      };

      img.addEventListener('load', onload);
    },
    addListeners: function addListeners() {
      this.isTicking = false;
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('scroll', this.handleScroll, true);
      window.addEventListener('keyup', this.handleKeyUp);
      window.addEventListener('ontouchstart', this.handleTouchStart);
      window.addEventListener('ontouchmove', this.handleTouchMove);
      window.addEventListener('ontouchend', this.handleTouchEnd);
      window.addEventListener('ontouchcancel', this.handleTouchEnd);
    },
    removeListeners: function removeListeners() {
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('scroll', this.handleScroll, true);
      window.removeEventListener('keyup', this.handleKeyUp);
      window.removeEventListener('touchstart', this.handleTouchStart);
      window.removeEventListener('touchmove', this.handleTouchMove);
      window.removeEventListener('touchend', this.handleTouchEnd);
      window.removeEventListener('touchcancel', this.handleTouchEnd);
    },
    handleResize: function handleResize() {
      this.$forceUpdate();
    },
    handleScroll: function handleScroll() {
      this.$forceUpdate();
      if (this.isZoomed) this.handleUnzoom();
    },
    handleKeyUp: function handleKeyUp(_ref3) {
      var which = _ref3.which;
      // eslint-disable-line
      var opts = {
        27: this.handleUnzoom
      };

      if (opts[which]) return opts[which](); // eslint-disable-line
    },
    handleTouchStart: function handleTouchStart(e) {
      this.yTouchPosition = e.touches[0].clientY;
    },
    handleTouchMove: function handleTouchMove(e) {
      this.$forceUpdate();
      var touchChange = Math.abs(e.touches[0].clientY - this.yTouchPosition);
      if (touchChange > 10 && this.isZoomed) this.handleUnzoom();
    },
    handleTouchEnd: function handleTouchEnd() {
      delete this.yTouchPosition;
    },
    handleUnzoom: function handleUnzoom(e) {
      var _this2 = this;

      if (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      }
      this.isZoomed = false;
      this.$nextTick(function () {
        setTimeout(_this2.onUnzoom(_this2.src), _defaults.transitionDuration);
      });
    },
    getZoomImageStyle: function getZoomImageStyle() {
      var image = this.image,
          shouldRespectMaxDimension = this.shouldRespectMaxDimension,
          zoomImage = this.zoomImage,
          zoomMargin = this.zoomMargin;

      var imageOffset = image.getBoundingClientRect();

      var top = imageOffset.top,
          left = imageOffset.left;
      var width = image.width,
          height = image.height,
          naturalWidth = image.naturalWidth,
          naturalHeight = image.naturalHeight;


      var style = {
        top: top + 'px',
        left: left + 'px',
        width: width + 'px',
        height: height + 'px'
      };

      if (!this.hasLoaded || !this.isZoomed) {
        return (0, _assign2.default)({}, _defaults2.default.styles.zoomImage, this.defaultStyles.zoomImage, this.style, style);
      }

      // get the coords for center of the viewport
      var viewportX = window.innerWidth / 2;
      var viewportY = window.innerHeight / 2;

      // get the coords for center of the original image
      var imageCenterX = imageOffset.left + width / 2; // eslint-disable-line
      var imageCenterY = imageOffset.top + height / 2; // eslint-disable-line

      // Get offset amounts for image coords to be centered on screen
      var translateX = viewportX - imageCenterX;
      var translateY = viewportY - imageCenterY;

      var scale = shouldRespectMaxDimension && !zoomImage.src ? getMaxDimensionScale({ width: width, height: height, naturalWidth: naturalWidth, naturalHeight: naturalHeight, zoomMargin: zoomMargin }) : getScale({ width: width, height: height, zoomMargin: zoomMargin });

      var zoomStyle = {
        transform: 'translate3d(' + translateX + 'px, ' + translateY + 'px, 0) scale(' + scale + ')'
      };

      return (0, _assign2.default)({}, _defaults2.default.styles.zoomImage, this.defaultStyles.zoomImage, style, zoomStyle);
    }
  }
};

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gazelle.1e9bd0c.jpg";

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nz-big.4e0ecfa.jpg";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/nz.ccfd807.jpg";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(56),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(58),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(55),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.ZoomContainerStyle),
    on: {
      "click": _vm.handleUnzoom
    }
  }, [_c('Overlay', {
    attrs: {
      "isVisible": _vm.isZoomed,
      "defaultStyle": _vm.defaultStyles.overlay
    }
  }), _vm._v(" "), _c('img', {
    class: _vm.zoomImage.className,
    style: (_vm.getZoomImageStyle()),
    attrs: {
      "alt": _vm.zoomImage.alt,
      "src": _vm.src
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shouldPreload && _vm.zoomImage && _vm.zoomImage.src) ? _c('span', [_c('link', {
    attrs: {
      "rel": "preload",
      "href": _vm.zoomImage.src,
      "as": "image"
    }
  }), _vm._v(" "), _c('img', {
    ref: "image",
    class: _vm.image.className,
    style: (_vm.getImageStyle()),
    attrs: {
      "src": _vm.image.src,
      "alt": _vm.image.alt
    },
    on: {
      "click": _vm.handleZoom
    }
  })]) : _c('img', {
    ref: "image",
    class: _vm.image.className,
    style: (_vm.getImageStyle()),
    attrs: {
      "src": _vm.image.src,
      "alt": _vm.image.alt
    },
    on: {
      "click": _vm.handleZoom
    }
  })
},staticRenderFns: []}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("Image Zoom")]), _vm._v(" "), _c('p', [_vm._v("Trust fund seitan chia, wolf lomo letterpress Bushwick before they sold out. Carles kogi fixie, squid twee Tonx readymade cred typewriter scenester locavore kale chips vegan organic. Meggings pug wolf Shoreditch typewriter skateboard. McSweeney's iPhone chillwave, food truck direct trade disrupt flannel irony tousled Cosby sweater single-origin coffee. Organic disrupt bicycle rights, tattooed messenger bag flannel craft beer fashion axe bitters. Readymade sartorial craft beer, quinoa sustainable butcher Marfa Echo Park Terry Richardson gluten-free flannel retro cred mlkshk banjo. Salvia 90's art party Blue Bottle, PBR&B cardigan 8-bit.")]), _vm._v(" "), _c('p', [_vm._v("Meggings irony fashion axe, tattooed master cleanse Blue Bottle stumptown bitters authentic flannel freegan paleo letterpress ugh sriracha. Wolf PBR&B art party aesthetic meh cliche. Sartorial before they sold out deep v, aesthetic PBR&B craft beer post-ironic synth keytar pork belly skateboard pour-over. Tonx cray pug Etsy, gastropub ennui wolf ethnic Odd Future viral master cleanse skateboard banjo. Pitchfork scenester cornhole, whatever try-hard ethnic banjo +1 gastropub American Apparel vinyl skateboard Shoreditch seitan. Blue Bottle keffiyeh Austin Helvetica art party. Portland ethnic fixie, beard retro direct trade ugh scenester Tumblr readymade authentic plaid pickled hashtag biodiesel.")]), _vm._v(" "), _c('div', [_c('ImageZoom', {
    attrs: {
      "defaultImage": {
        src: __webpack_require__(14),
        alt: 'Golden Gate Bridge',
        className: 'img'
      },
      "zoomImage": {
        src: __webpack_require__(13),
        alt: 'Golden Gate Bridge',
        className: 'img--zoomed'
      },
      "shouldPreload": true
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Thundercats freegan Truffaut, four loko twee Austin scenester lo-fi seitan High Life paleo quinoa cray. Schlitz butcher ethical Tumblr, pop-up DIY keytar ethnic iPhone PBR sriracha. Tonx direct trade bicycle rights gluten-free flexitarian asymmetrical. Whatever drinking vinegar PBR XOXO Bushwick gentrify. Cliche semiotics banjo retro squid Wes Anderson. Fashion axe dreamcatcher you probably haven't heard of them bicycle rights. Tote bag organic four loko ethical selfies gastropub, PBR fingerstache tattooed bicycle rights.")]), _vm._v(" "), _c('div', {
    style: ({
      float: 'left',
      margin: '0 1.5em 0 0'
    })
  }, [_c('ImageZoom', {
    attrs: {
      "defaultImage": {
        src: __webpack_require__(51),
        alt: 'Picture of Mt. Cook in New Zealand',
        className: 'img',
        style: {
          width: '20em'
        }
      },
      "zoomImage": {
        src: __webpack_require__(50),
        alt: 'Picture of Mt. Cook in New Zealand',
        className: 'img--zoomed'
      }
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Ugh Portland Austin, distillery tattooed typewriter polaroid pug Banksy Neutra keffiyeh. Shoreditch mixtape wolf PBR&B, tote bag dreamcatcher literally bespoke Odd Future selfies 90's master cleanse vegan. Flannel tofu deep v next level pickled, authentic Etsy Shoreditch literally swag photo booth iPhone pug semiotics banjo. Bicycle rights butcher Blue Bottle, actually DIY semiotics Banksy banjo mixtape Austin pork belly post-ironic. American Apparel gastropub hashtag, McSweeney's master cleanse occupy High Life bitters wayfarers next level bicycle rights. Wolf chia Terry Richardson, pop-up plaid kitsch ugh. Butcher +1 Carles, swag selfies Blue Bottle viral.")]), _vm._v(" "), _c('p', [_vm._v("Keffiyeh food truck organic letterpress leggings iPhone four loko hella pour-over occupy, Wes Anderson cray post-ironic. Neutra retro fixie gastropub +1, High Life semiotics. Vinyl distillery Etsy freegan flexitarian cliche jean shorts, Schlitz wayfarers skateboard tousled irony locavore XOXO meh. Ethnic Wes Anderson McSweeney's messenger bag, mixtape XOXO slow-carb cornhole aesthetic Marfa banjo Thundercats bitters. Raw denim banjo typewriter cray Tumblr, High Life single-origin coffee. 90's Tumblr cred, Terry Richardson occupy raw denim tofu fashion axe photo booth banh mi. Trust fund locavore Helvetica, fashion axe selvage authentic Shoreditch swag selfies stumptown +1.")]), _vm._v(" "), _c('div', [_c('ImageZoom', {
    attrs: {
      "defaultImage": {
        src: __webpack_require__(49),
        alt: 'Gazelle Stomping',
        title: 'Dont exceed original image dimensions...',
        className: 'img',
        style: {
          width: '80%'
        }
      },
      "shouldRespectMaxDimension": true
    }
  })], 1), _vm._v(" "), _c('p', [_vm._v("Scenester chambray slow-carb, trust fund biodiesel ugh bicycle rights cornhole. Gentrify messenger bag Truffaut tousled roof party pork belly leggings, photo booth jean shorts. Austin readymade PBR plaid chambray. Squid Echo Park pour-over, wayfarers forage whatever locavore typewriter artisan deep v four loko. Locavore occupy Neutra Pitchfork McSweeney's, wayfarers fingerstache. Actually asymmetrical drinking vinegar yr brunch biodiesel. Before they sold out sustainable readymade craft beer Portland gastropub squid Austin, roof party Thundercats chambray narwhal Bushwick pug.")]), _vm._v(" "), _c('p', [_vm._v("Literally typewriter chillwave, bicycle rights Carles flannel wayfarers. Biodiesel farm-to-table actually, locavore keffiyeh hella shabby chic pour-over try-hard Bushwick. Sriracha American Apparel Brooklyn, synth cray stumptown blog Bushwick +1 VHS hashtag. Wolf umami Carles Marfa, 90's food truck Cosby sweater. Fanny pack try-hard keytar pop-up readymade, master cleanse four loko trust fund polaroid salvia. Photo booth kitsch forage chambray, Carles scenester slow-carb lomo cardigan dreamcatcher. Swag asymmetrical leggings, biodiesel Tonx shabby chic ethnic master cleanse freegan.")]), _vm._v(" "), _c('p', [_vm._v("Raw denim Banksy shabby chic, 8-bit salvia narwhal fashion axe. Ethical Williamsburg four loko, chia kale chips distillery Shoreditch messenger bag swag iPhone Pitchfork. Viral PBR&B single-origin coffee quinoa readymade, ethical chillwave drinking vinegar gluten-free Wes Anderson kitsch Tumblr synth actually bitters. Butcher McSweeney's forage mlkshk kogi fingerstache. Selvage scenester butcher Shoreditch, Carles beard plaid disrupt DIY. Pug readymade selvage retro, Austin salvia vinyl master cleanse flexitarian deep v bicycle rights plaid Terry Richardson mlkshk pour-over. Trust fund try-hard banh mi Brooklyn, 90's Etsy kogi YOLO salvia.")])])
},staticRenderFns: []}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.customStyle)
  })
},staticRenderFns: []}

/***/ })
],[16]);


// WEBPACK FOOTER //
// static/js/app.dfb96af366c81b7ce36f.js